module.exports = __webpack_public_path__ + "static/dan2-7d132f72409b6af403e1738cd5b1db83.png";